<ion-grid *ngIf="ugy">
  <ion-row class="ion-align-items-center">
    <ion-col size="auto"><ion-button fill="clear" (click)="vissza()"><ion-icon name="arrow-back"></ion-icon></ion-button></ion-col>
    <ion-col>
      <h2 style="margin:0"><b>{{ ugy.ugyazonosito }}</b> — {{ ugy.leiras }}</h2>
      <p style="margin:0;color:var(--ion-color-medium)">
        {{ ugy.ugytipus_nev || 'Be nem sorolt ügy' }} · {{ cimke(opciok.allapot, ugy.allapot) }}
        <span *ngIf="ugy.ugygazda"> · {{ ugy.ugygazda }}</span>
      </p>
    </ion-col>
  </ion-row>
</ion-grid>

<ion-segment scrollable [value]="segment" (ionChange)="valtas($event)">
  <ion-segment-button value="attekintes"><ion-label>Áttekintés</ion-label></ion-segment-button>
  <ion-segment-button *ngIf="ugy?.hibrid" value="mappa"><ion-label>Mappa</ion-label></ion-segment-button>
  <ion-segment-button value="szereplok"><ion-label>Szereplők</ion-label></ion-segment-button>
  <ion-segment-button value="iratok"><ion-label>Iratok</ion-label></ion-segment-button>
  <ion-segment-button value="hivatkozasok"><ion-label>Hivatkozások</ion-label></ion-segment-button>
  <ion-segment-button value="hataridok"><ion-label>Határidők</ion-label></ion-segment-button>
  <ion-segment-button value="penzugy"><ion-label>Pénzügy</ion-label></ion-segment-button>
  <ion-segment-button value="pmt"><ion-label>PMT</ion-label></ion-segment-button>
  <ion-segment-button value="postakonyv"><ion-label>Postakönyv</ion-label></ion-segment-button>
</ion-segment>

<!-- ÁTTEKINTÉS -->
<div *ngIf="segment === 'attekintes' && ugy" class="ion-padding">
  <ion-note color="warning" *ngIf="ugy.hibrid" class="ion-margin-bottom" style="display:block">
    <ion-icon name="lock-closed" style="vertical-align:middle"></ion-icon>
    Hibrid ügy – a lemezen lévő mappából olvasva, <b>csak megtekintés</b>. Lásd a <b>Mappa</b> fület a fájlokhoz.
  </ion-note>
  <ion-list>
    <ion-item><ion-input label="Ügy megnevezése *" labelPlacement="stacked" [(ngModel)]="ugy.leiras" [disabled]="ugy.hibrid"></ion-input></ion-item>
    <ion-item>
      <ion-select label="Ügytípus" labelPlacement="stacked" [(ngModel)]="ugy.ugytipus_id" interface="popover" [disabled]="ugy.hibrid">
        <ion-select-option [value]="null">Be nem sorolt ügy</ion-select-option>
        <ion-select-option *ngFor="let t of ugytipusValaszthato()" [value]="t.id">{{ t.label }}</ion-select-option>
      </ion-select>
    </ion-item>
    <ion-item>
      <ion-select label="Állapot" labelPlacement="stacked" [(ngModel)]="ugy.allapot" interface="popover">
        <ion-select-option *ngFor="let o of opciok.allapot" [value]="o.value">{{ o.label }}</ion-select-option>
      </ion-select>
    </ion-item>
    <ion-item><ion-input label="Ügygazda" labelPlacement="stacked" [(ngModel)]="ugy.ugygazda"></ion-input></ion-item>
    <ion-item><ion-input type="date" label="Megbízás dátuma" labelPlacement="stacked" [(ngModel)]="ugy.megbizas_datum"></ion-input></ion-item>
    <ion-item><ion-input type="date" label="Lezárás dátuma" labelPlacement="stacked" [(ngModel)]="ugy.lezaras_datum"></ion-input></ion-item>
    <ion-item><ion-input type="number" label="Óradíj (Ft)" labelPlacement="stacked" [(ngModel)]="ugy.oradij"></ion-input></ion-item>
    <ion-item><ion-input label="PMT-besorolás" labelPlacement="stacked" [(ngModel)]="ugy.pmt_besorolas"></ion-input></ion-item>
    <ion-item>
      <ion-checkbox slot="start" [(ngModel)]="ugy.selejtezheto"></ion-checkbox>
      <ion-label>Selejtezhető</ion-label>
    </ion-item>
  </ion-list>
  <ion-chip><ion-icon name="document-attach"></ion-icon><ion-label>{{ osszesites.iratok || 0 }} irat</ion-label></ion-chip>
  <ion-button *ngIf="!ugy.hibrid" expand="block" (click)="mentUgy()">Mentés</ion-button>
  <ion-button *ngIf="!ugy.hibrid" expand="block" fill="outline" color="danger" (click)="torolUgy()">Ügy törlése</ion-button>
</div>

<!-- MAPPA (hibrid, read-only) -->
<div *ngIf="segment === 'mappa'" class="ion-padding">
  <ion-note color="medium" style="display:block">A fájlok a lemezen lévő eredeti mappában vannak – kattints valamelyikre a megnyitáshoz (az eredeti fájl/mappa nyílik meg a gépeden).</ion-note>
  <p *ngIf="hibridGyoker" style="word-break:break-all">
    <ion-icon name="folder-open" color="warning"></ion-icon> <code>{{ hibridGyoker }}</code>
    <ion-button size="small" fill="clear" (click)="megnyitLemezen('.')"><ion-icon slot="start" name="open-outline"></ion-icon>Mappa megnyitása</ion-button>
  </p>
  <ion-note color="danger" *ngIf="hibridHiba" style="display:block">{{ hibridHiba }}</ion-note>
  <ion-note color="medium" *ngIf="!hibridHiba && !hibridFa.length" style="display:block">A mappa üres.</ion-note>
  <ng-container *ngTemplateOutlet="faSablon; context: { $implicit: hibridFa, szint: 0 }"></ng-container>
</div>

<!-- Rekurzív mappafa-sablon -->
<ng-template #faSablon let-elemek let-szint="szint">
  <ion-list lines="none" style="padding:0">
    <ng-container *ngFor="let e of elemek">
      <ion-item button detail="false" (click)="megnyitLemezen(e.rel)" [style.--padding-start.px]="12 + szint*18">
        <ion-icon slot="start" [name]="e.tipus === 'mappa' ? 'folder' : 'document-text'" [color]="e.tipus === 'mappa' ? 'warning' : 'medium'"></ion-icon>
        <ion-label><h3>{{ e.nev }}</h3></ion-label>
        <ion-icon slot="end" name="open-outline" color="primary"></ion-icon>
      </ion-item>
      <ng-container *ngIf="e.tipus === 'mappa' && e.gyerekek?.length"
        [ngTemplateOutlet]="faSablon" [ngTemplateOutletContext]="{ $implicit: e.gyerekek, szint: szint + 1 }"></ng-container>
    </ng-container>
  </ion-list>
</ng-template>

<!-- SZEREPLŐK -->
<div *ngIf="segment === 'szereplok'" class="ion-padding">
  <ion-button (click)="ujSzereploModal()"><ion-icon slot="start" name="person-add"></ion-icon>Szereplő hozzáadása</ion-button>
  <ion-list lines="full">
    <ion-item *ngIf="szereplok.length === 0"><ion-label color="medium">Nincs szereplő.</ion-label></ion-item>
    <div *ngFor="let s of szereplok" class="szereplo-blokk">
      <ion-item lines="none">
        <ion-icon slot="start" [name]="s.tipus === 'jogi' ? 'business' : s.tipus === 'hatosag' ? 'shield' : 'person'" color="primary"></ion-icon>
        <ion-label>
          <h3>{{ s.nev }}</h3>
          <ion-input fill="outline" style="max-width:220px;margin-top:4px" [(ngModel)]="s.szerep" (ionBlur)="szereploFrissit(s)"></ion-input>
        </ion-label>
        <ion-checkbox slot="end" [(ngModel)]="s.sajat_ugyfel" (ionChange)="szereploFrissit(s)">Saját ügyfél</ion-checkbox>
        <ion-button slot="end" fill="clear" color="danger" (click)="szereploTorol(s)"><ion-icon name="trash"></ion-icon></ion-button>
      </ion-item>
      <!-- Egyedi (loop-)mezők: a sablon ismétlődő szakaszában ${kulcs} néven érhetők el (pl. hanyad) -->
      <div class="extra-szerk">
        <div class="extra-fejlec">
          <small>Egyedi mezők (loop-változókhoz, pl. <code>hanyad</code>)</small>
          <ion-button size="small" fill="clear" (click)="extraSorHozzad(s)"><ion-icon slot="icon-only" name="add"></ion-icon></ion-button>
        </div>
        <div *ngFor="let e of s.extraSorok; let i = index" class="extra-sor">
          <ion-input fill="outline" placeholder="kulcs (pl. hanyad)" [(ngModel)]="e.kulcs"></ion-input>
          <ion-input fill="outline" placeholder="érték (pl. 1/2)" [(ngModel)]="e.ertek"></ion-input>
          <ion-button fill="clear" color="danger" (click)="extraSorTorol(s, i)"><ion-icon slot="icon-only" name="close"></ion-icon></ion-button>
        </div>
        <ion-button *ngIf="s.extraSorok?.length" size="small" fill="outline" (click)="szereploFrissit(s)">Egyedi mezők mentése</ion-button>
      </div>
    </div>
  </ion-list>
</div>

<!-- IRATOK -->
<div *ngIf="segment === 'iratok'" class="ion-padding">
  <ion-button (click)="iratkeszModalNyit()"><ion-icon slot="start" name="sparkles"></ion-icon>Irat készítése sablonból</ion-button>
  <ion-row>
    <ion-col>
      <ion-select label="Irány" labelPlacement="stacked" [(ngModel)]="feltoltIrany" interface="popover">
        <ion-select-option *ngFor="let o of opciok.iratIrany" [value]="o.value">{{ o.label }}</ion-select-option>
      </ion-select>
    </ion-col>
    <ion-col>
      <ion-select label="Irat típusa" labelPlacement="stacked" [(ngModel)]="feltoltTipus" interface="popover">
        <ion-select-option *ngFor="let o of opciok.iratTipus" [value]="o.value">{{ o.label }}</ion-select-option>
      </ion-select>
    </ion-col>
  </ion-row>
  <input type="file" (change)="feltolt($event)" />
  <ion-list lines="full">
    <ion-item *ngIf="iratok.length === 0"><ion-label color="medium">Nincs csatolt irat.</ion-label></ion-item>
    <ion-item *ngFor="let i of iratok">
      <ion-icon slot="start" [name]="i.irany === 'kimeno' ? 'arrow-up' : i.irany === 'beerkezo' ? 'arrow-down' : 'document-text'" color="primary"></ion-icon>
      <ion-label>
        <h3>{{ i.nev }}</h3>
        <p>{{ cimke(opciok.iratIrany, i.irany) }} · {{ cimke(opciok.iratTipus, i.tipus) }} · {{ (i.meret/1024) | number:'1.0-0' }} KB · {{ i.letrehozva | date:'yyyy-MM-dd' }}</p>
      </ion-label>
      <ion-button slot="end" fill="clear" (click)="letolt(i)"><ion-icon name="download"></ion-icon></ion-button>
      <ion-button slot="end" fill="clear" color="danger" (click)="torolIrat(i)"><ion-icon name="trash"></ion-icon></ion-button>
    </ion-item>
  </ion-list>
</div>

<!-- HIVATKOZÁSOK -->
<div *ngIf="segment === 'hivatkozasok'" class="ion-padding">
  <p style="color:var(--ion-color-medium)">A hatóságok ügyszámai. Ezek alapján a beérkező PDF-eket az Iktató automatikusan ehhez az ügyhöz tudja rendelni.</p>
  <ion-list lines="full">
    <ion-item *ngIf="hivatkozasok.length === 0"><ion-label color="medium">Nincs hivatkozási szám.</ion-label></ion-item>
    <ion-item *ngFor="let h of hivatkozasok">
      <ion-icon slot="start" name="pricetag" color="primary"></ion-icon>
      <ion-label>
        <h3>{{ h.szam }}</h3>
        <p>{{ h.hatosag_nev }}<span *ngIf="h.megjegyzes"> · {{ h.megjegyzes }}</span></p>
      </ion-label>
      <ion-button slot="end" fill="clear" color="danger" (click)="hivTorol(h)"><ion-icon name="trash"></ion-icon></ion-button>
    </ion-item>
  </ion-list>
  <ion-list>
    <ion-item>
      <ion-input label="Hatóság" labelPlacement="stacked" [(ngModel)]="ujHiv.hatosag_nev" list="caesar-hatosagok" placeholder="pl. Szombathelyi Járásbíróság"></ion-input>
      <datalist id="caesar-hatosagok"><option *ngFor="let ha of hatosagok" [value]="ha.nev"></option></datalist>
    </ion-item>
    <ion-item><ion-input label="Hivatkozási szám" labelPlacement="stacked" [(ngModel)]="ujHiv.szam" placeholder="pl. P.20.100/2026"></ion-input></ion-item>
    <ion-item><ion-input label="Megjegyzés" labelPlacement="stacked" [(ngModel)]="ujHiv.megjegyzes"></ion-input></ion-item>
  </ion-list>
  <ion-button expand="block" (click)="hivAdd()">Hivatkozási szám hozzáadása</ion-button>
</div>

<!-- HATÁRIDŐK -->
<div *ngIf="segment === 'hataridok'" class="ion-padding">
  <ion-list-header><ion-label>Határnapok</ion-label></ion-list-header>
  <ion-list lines="full">
    <ion-item *ngIf="hatarnapok.length === 0"><ion-label color="medium">Nincs határnap.</ion-label></ion-item>
    <ion-item *ngFor="let h of hatarnapok">
      <ion-badge slot="start" [color]="hatarnapSzin(h.datum)">{{ h.datum }}</ion-badge>
      <ion-label><h3>{{ h.megnevezes }}</h3><p>{{ h.idopont }}<span *ngIf="h.hely"> · {{ h.hely }}</span></p></ion-label>
      <ion-button slot="end" fill="clear" color="danger" (click)="hatarnapTorol(h)"><ion-icon name="trash"></ion-icon></ion-button>
    </ion-item>
  </ion-list>
  <ion-row>
    <ion-col><ion-item><ion-input type="date" label="Dátum" labelPlacement="stacked" [(ngModel)]="ujHatarnap.datum"></ion-input></ion-item></ion-col>
    <ion-col><ion-item><ion-input label="Időpont" labelPlacement="stacked" [(ngModel)]="ujHatarnap.idopont" placeholder="9:00"></ion-input></ion-item></ion-col>
  </ion-row>
  <ion-item><ion-input label="Megnevezés" labelPlacement="stacked" [(ngModel)]="ujHatarnap.megnevezes" placeholder="pl. tárgyalás"></ion-input></ion-item>
  <ion-item><ion-input label="Helyszín" labelPlacement="stacked" [(ngModel)]="ujHatarnap.hely"></ion-input></ion-item>
  <ion-button expand="block" (click)="hatarnapAdd()">Határnap hozzáadása</ion-button>

  <ion-list-header style="margin-top:18px"><ion-label>Tennivalók</ion-label></ion-list-header>
  <ion-list lines="full">
    <ion-item *ngIf="tennivalok.length === 0"><ion-label color="medium">Nincs tennivaló.</ion-label></ion-item>
    <ion-item *ngFor="let t of tennivalok">
      <ion-checkbox slot="start" [(ngModel)]="t.kesz" (ionChange)="tennivaloKesz(t)"></ion-checkbox>
      <ion-label [style.textDecoration]="t.kesz ? 'line-through' : ''">
        <h3>{{ t.szoveg }}</h3><p>{{ t.datum }}<span *ngIf="t.felelos"> · {{ t.felelos }}</span> · {{ t.tipus }}</p>
      </ion-label>
      <ion-button slot="end" fill="clear" color="danger" (click)="tennivaloTorol(t)"><ion-icon name="trash"></ion-icon></ion-button>
    </ion-item>
  </ion-list>
  <ion-row>
    <ion-col><ion-item><ion-input type="date" label="Határidő" labelPlacement="stacked" [(ngModel)]="ujTennivalo.datum"></ion-input></ion-item></ion-col>
    <ion-col><ion-item><ion-select label="Típus" labelPlacement="stacked" [(ngModel)]="ujTennivalo.tipus" interface="popover"><ion-select-option value="tennivalo">Tennivaló</ion-select-option><ion-select-option value="megjegyzes">Megjegyzés</ion-select-option></ion-select></ion-item></ion-col>
  </ion-row>
  <ion-item><ion-input label="Szöveg" labelPlacement="stacked" [(ngModel)]="ujTennivalo.szoveg"></ion-input></ion-item>
  <ion-item><ion-input label="Felelős" labelPlacement="stacked" [(ngModel)]="ujTennivalo.felelos"></ion-input></ion-item>
  <ion-button expand="block" (click)="tennivaloAdd()">Tennivaló hozzáadása</ion-button>
</div>

<!-- PÉNZÜGY -->
<div *ngIf="segment === 'penzugy'" class="ion-padding">
  <ion-list-header><ion-label>Óradíj-tételek</ion-label></ion-list-header>
  <ion-row>
    <ion-col><ion-chip color="primary"><ion-label>Összes munkadíj: {{ oradijOsszesen | number }} Ft</ion-label></ion-chip></ion-col>
    <ion-col><ion-chip color="warning"><ion-label>Számlázatlan: {{ oradijSzamlazatlan | number }} Ft</ion-label></ion-chip></ion-col>
  </ion-row>
  <ion-list lines="full">
    <ion-item *ngFor="let o of oradijak">
      <ion-label>
        <h3>{{ o.leiras }} — {{ o.osszeg | number }} {{ o.penznem }}</h3>
        <p>{{ o.datum }} · {{ o.ido_perc }} perc<span *ngIf="o.szamla_sorszam"> · számla: {{ o.szamla_sorszam }}</span></p>
      </ion-label>
      <ion-checkbox slot="end" [(ngModel)]="o.szamlazva" (ionChange)="oradijToggle(o,'szamlazva')">Számlázva</ion-checkbox>
      <ion-button slot="end" fill="clear" color="danger" (click)="oradijTorol(o)"><ion-icon name="trash"></ion-icon></ion-button>
    </ion-item>
  </ion-list>
  <ion-row>
    <ion-col><ion-item><ion-input type="date" label="Dátum" labelPlacement="stacked" [(ngModel)]="ujOradij.datum"></ion-input></ion-item></ion-col>
    <ion-col><ion-item><ion-input type="number" label="Idő (perc)" labelPlacement="stacked" [(ngModel)]="ujOradij.ido_perc"></ion-input></ion-item></ion-col>
    <ion-col><ion-item><ion-input type="number" label="Óradíj" labelPlacement="stacked" [(ngModel)]="ujOradij.oradij"></ion-input></ion-item></ion-col>
  </ion-row>
  <ion-item><ion-input label="Leírás (munka)" labelPlacement="stacked" [(ngModel)]="ujOradij.leiras"></ion-input></ion-item>
  <ion-note class="ion-padding-start" color="medium">Számított összeg (megkezdett óra): {{ oradijElonezet(ujOradij) | number }} Ft</ion-note>
  <ion-button expand="block" (click)="oradijAdd()">Óradíj-tétel hozzáadása</ion-button>
  <ion-button expand="block" fill="outline" (click)="szamlazNav()"><ion-icon slot="start" name="receipt"></ion-icon>Munkadíj számlázása (NAV)</ion-button>

  <ion-list-header style="margin-top:18px"><ion-label>Költségek (eljárási / tranzakciós)</ion-label></ion-list-header>
  <ion-list lines="full">
    <ion-item *ngFor="let k of koltsegek">
      <ion-label>
        <h3>{{ k.megnevezes }} — {{ k.osszeg | number }} {{ k.penznem }} <ion-badge>{{ k.kategoria }}</ion-badge></h3>
        <p *ngIf="k.tovabbutalas">továbbutalás · tranzakciós díj: {{ k.tranzakcios_dij | number }} Ft</p>
      </ion-label>
      <ion-button slot="end" fill="clear" color="danger" (click)="koltsegTorol(k)"><ion-icon name="trash"></ion-icon></ion-button>
    </ion-item>
  </ion-list>
  <ion-row>
    <ion-col><ion-item><ion-select label="Kategória" labelPlacement="stacked" [(ngModel)]="ujKoltseg.kategoria" interface="popover"><ion-select-option value="eljarasi">Eljárási</ion-select-option><ion-select-option value="tranzakcios">Tranzakciós</ion-select-option></ion-select></ion-item></ion-col>
    <ion-col><ion-item><ion-input type="number" label="Összeg" labelPlacement="stacked" [(ngModel)]="ujKoltseg.osszeg"></ion-input></ion-item></ion-col>
  </ion-row>
  <ion-item><ion-input label="Megnevezés" labelPlacement="stacked" [(ngModel)]="ujKoltseg.megnevezes"></ion-input></ion-item>
  <ion-item *ngIf="ujKoltseg.kategoria === 'eljarasi'">
    <ion-checkbox slot="start" [(ngModel)]="ujKoltseg.tovabbutalas"></ion-checkbox>
    <ion-label>Ügyfél továbbutaltatja (tranzakciós díj ~{{ tranzElonezet(ujKoltseg) | number }} Ft)</ion-label>
  </ion-item>
  <ion-button expand="block" (click)="koltsegAdd()">Költség hozzáadása</ion-button>

  <ion-list-header style="margin-top:18px"><ion-label>Letétek</ion-label></ion-list-header>
  <ion-list lines="full">
    <ion-item *ngFor="let l of letetek">
      <ion-icon slot="start" [name]="l.statusz === 'nyitott' ? 'lock-open' : 'lock-closed'" [color]="l.statusz === 'nyitott' ? 'warning' : 'success'"></ion-icon>
      <ion-label><h3>{{ l.jogcim }} — {{ l.osszeg | number }} {{ l.penznem }}</h3><p>{{ l.atvetel_datum }} · {{ l.statusz }}</p></ion-label>
      <ion-button *ngIf="l.statusz === 'nyitott'" slot="end" size="small" (click)="letetLezar(l)">Lezárás</ion-button>
      <ion-button slot="end" fill="clear" color="danger" (click)="letetTorol(l)"><ion-icon name="trash"></ion-icon></ion-button>
    </ion-item>
  </ion-list>
  <ion-row>
    <ion-col><ion-item><ion-input label="Jogcím" labelPlacement="stacked" [(ngModel)]="ujLetet.jogcim"></ion-input></ion-item></ion-col>
    <ion-col><ion-item><ion-input type="number" label="Összeg" labelPlacement="stacked" [(ngModel)]="ujLetet.osszeg"></ion-input></ion-item></ion-col>
  </ion-row>
  <ion-button expand="block" (click)="letetAdd()">Letét hozzáadása</ion-button>
</div>

<!-- PMT -->
<div *ngIf="segment === 'pmt'" class="ion-padding">
  <p style="color:var(--ion-color-medium)">Pénzmosás elleni (PMT) minősítés az ügyhöz. A személyek minősítését a Személyek nézetben kezeld.</p>
  <ion-list lines="full">
    <ion-item *ngFor="let p of pmtek">
      <ion-icon slot="start" name="shield-half" [color]="p.kockazat === 'magas' ? 'danger' : p.kockazat === 'atlagos' ? 'warning' : 'success'"></ion-icon>
      <ion-label>
        <h3>{{ p.besorolas || '(besorolás nélkül)' }} <ion-badge>{{ p.kockazat }}</ion-badge></h3>
        <p>{{ p.datum }}<span *ngIf="p.ugyleti_ertek"> · ügyleti érték: {{ p.ugyleti_ertek | number }} Ft</span><span *ngIf="p.atvilagitas"> · átvilágítás kötelező</span></p>
      </ion-label>
      <ion-button slot="end" fill="clear" color="danger" (click)="pmtTorol(p)"><ion-icon name="trash"></ion-icon></ion-button>
    </ion-item>
  </ion-list>
  <ion-item><ion-input label="PMT besorolás" labelPlacement="stacked" [(ngModel)]="ujPmt.besorolas" placeholder="pl. Ingatlan tulajdon átruházása"></ion-input></ion-item>
  <ion-row>
    <ion-col><ion-item><ion-select label="Kockázat" labelPlacement="stacked" [(ngModel)]="ujPmt.kockazat" interface="popover"><ion-select-option value="alacsony">Alacsony</ion-select-option><ion-select-option value="atlagos">Átlagos</ion-select-option><ion-select-option value="magas">Magas</ion-select-option></ion-select></ion-item></ion-col>
    <ion-col><ion-item><ion-input type="number" label="Ügyleti érték (Ft)" labelPlacement="stacked" [(ngModel)]="ujPmt.ugyleti_ertek"></ion-input></ion-item></ion-col>
  </ion-row>
  <ion-item><ion-checkbox slot="start" [(ngModel)]="ujPmt.atvilagitas"></ion-checkbox><ion-label>Átvilágítási kötelezettség</ion-label></ion-item>
  <ion-button expand="block" (click)="pmtAdd()">PMT minősítés rögzítése</ion-button>
</div>

<!-- POSTAKÖNYV -->
<div *ngIf="segment === 'postakonyv'" class="ion-padding">
  <ion-list lines="full">
    <ion-item *ngIf="levelek.length === 0"><ion-label color="medium">Nincs levél.</ion-label></ion-item>
    <ion-item *ngFor="let l of levelek">
      <ion-icon slot="start" [name]="l.irany === 'kimeno' ? 'arrow-up' : 'arrow-down'" color="primary"></ion-icon>
      <ion-label><h3>{{ l.partner || '(nincs partner)' }}</h3><p>{{ l.datum }}<span *ngIf="l.ragszam"> · rag: {{ l.ragszam }}</span><span *ngIf="l.leiras"> · {{ l.leiras }}</span></p></ion-label>
      <ion-button slot="end" fill="clear" color="danger" (click)="levelTorol(l)"><ion-icon name="trash"></ion-icon></ion-button>
    </ion-item>
  </ion-list>
  <ion-row>
    <ion-col><ion-item><ion-select label="Irány" labelPlacement="stacked" [(ngModel)]="ujLevel.irany" interface="popover"><ion-select-option value="kimeno">Kimenő</ion-select-option><ion-select-option value="bejovo">Bejövő</ion-select-option></ion-select></ion-item></ion-col>
    <ion-col><ion-item><ion-input type="date" label="Dátum" labelPlacement="stacked" [(ngModel)]="ujLevel.datum"></ion-input></ion-item></ion-col>
  </ion-row>
  <ion-item><ion-input label="Partner (címzett/feladó)" labelPlacement="stacked" [(ngModel)]="ujLevel.partner"></ion-input></ion-item>
  <ion-row>
    <ion-col><ion-item><ion-input label="Ragszám" labelPlacement="stacked" [(ngModel)]="ujLevel.ragszam"></ion-input></ion-item></ion-col>
    <ion-col><ion-item><ion-input label="Leírás" labelPlacement="stacked" [(ngModel)]="ujLevel.leiras"></ion-input></ion-item></ion-col>
  </ion-row>
  <ion-button expand="block" (click)="levelAdd()">Levél rögzítése</ion-button>
</div>

<!-- SZEREPLŐ MODAL -->
<ion-modal #szereploModal>
  <ng-template>
    <ion-header><ion-toolbar color="primary">
      <ion-title>Szereplő hozzáadása</ion-title>
      <ion-buttons slot="end"><ion-button (click)="szereploModal.dismiss()">Mégse</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content class="ion-padding">
      <ion-list>
        <!-- Kereshetős személyválasztó -->
        <ion-searchbar [(ngModel)]="szemelyKereso" placeholder="Személy keresése a törzsből (név, szül. hely, szem. szám)…"></ion-searchbar>
        <ion-list *ngIf="szemelyKereso.trim()" lines="full" style="max-height:220px;overflow:auto">
          <ion-item button *ngFor="let s of szemelyTalalatok" (click)="valasztSzemely(s)">
            <ion-icon slot="start" name="person" color="primary"></ion-icon>
            <ion-label><h3>{{ s.nev }}</h3><p><span *ngIf="s.szuletesi_ido">{{ s.szuletesi_ido }}</span><span *ngIf="s.szuletesi_hely"> · {{ s.szuletesi_hely }}</span></p></ion-label>
          </ion-item>
          <ion-item *ngIf="szemelyTalalatok.length === 0"><ion-label color="medium">Nincs találat.</ion-label></ion-item>
        </ion-list>
        <ion-chip *ngIf="szemelyValasztott" color="primary" outline="true">
          <ion-icon name="person"></ion-icon><ion-label>{{ szemelyValasztott.nev }}</ion-label>
          <ion-icon name="close-circle" (click)="szemelyValasztott=null; ujSzereplo.szemely_id=''"></ion-icon>
        </ion-chip>

        <ion-item>
          <ion-select label="Szerepkör" labelPlacement="stacked" [(ngModel)]="ujSzereplo.szerep" interface="popover">
            <ion-select-option *ngFor="let o of opciok.szerep" [value]="o.value">{{ o.label }}</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item *ngIf="ujSzereplo.szerep === 'Egyéb'">
          <ion-input label="Egyéb szerepkör megnevezése" labelPlacement="stacked" [(ngModel)]="ujSzereplo.szerepEgyeb" placeholder="pl. Kezes, Örökös, Szakértő…"></ion-input>
        </ion-item>
        <ion-item><ion-checkbox slot="start" [(ngModel)]="ujSzereplo.sajat_ugyfel"></ion-checkbox><ion-label>Saját ügyfél</ion-label></ion-item>
      </ion-list>

      <!-- Egyedi (loop-)mezők, pl. tulajdoni hányad → a sablon loopjában ${hanyad} -->
      <div class="extra-szerk ion-padding-top">
        <div class="extra-fejlec">
          <small>Egyedi mezők (loop-változókhoz, pl. <code>hanyad</code> = 1/2)</small>
          <ion-button size="small" fill="clear" (click)="extraSorHozzad(ujSzereplo)"><ion-icon slot="icon-only" name="add"></ion-icon></ion-button>
        </div>
        <div *ngFor="let e of ujSzereplo.extraSorok; let i = index" class="extra-sor">
          <ion-input fill="outline" placeholder="kulcs (pl. hanyad)" [(ngModel)]="e.kulcs"></ion-input>
          <ion-input fill="outline" placeholder="érték (pl. 1/2)" [(ngModel)]="e.ertek"></ion-input>
          <ion-button fill="clear" color="danger" (click)="extraSorTorol(ujSzereplo, i)"><ion-icon slot="icon-only" name="close"></ion-icon></ion-button>
        </div>
      </div>

      <ion-note class="ion-padding-start" color="medium">Új személyt a Személyek fülön tudsz felvenni.</ion-note>
      <ion-button expand="block" (click)="szereploMent()">Hozzáadás</ion-button>
    </ion-content>
  </ng-template>
</ion-modal>

<!-- IRATKÉSZÍTÉS MODAL -->
<ion-modal #iratkeszModal>
  <ng-template>
    <ion-header><ion-toolbar color="primary">
      <ion-title>Irat készítése</ion-title>
      <ion-buttons slot="end"><ion-button (click)="iratkeszModal.dismiss()">Mégse</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content class="ion-padding">
      <ion-segment [(ngModel)]="iratkesz.mod" (ionChange)="iratkesz.id=''; iratkesz.mezok=[]">
        <ion-segment-button value="sablon"><ion-label>Sablon</ion-label></ion-segment-button>
        <ion-segment-button value="varazslo"><ion-label>Varázsló</ion-label></ion-segment-button>
      </ion-segment>

      <ion-list>
        <ion-item *ngIf="iratkesz.mod === 'sablon'">
          <ion-select label="Sablon" labelPlacement="stacked" [(ngModel)]="iratkesz.id" (ionChange)="forrasValt()" interface="alert" placeholder="Válassz sablont">
            <ion-select-option *ngFor="let s of sablonok" [value]="s.id">{{ s.nev }}</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item *ngIf="iratkesz.mod === 'varazslo'">
          <ion-select label="Varázsló" labelPlacement="stacked" [(ngModel)]="iratkesz.id" (ionChange)="forrasValt()" interface="alert" placeholder="Válassz varázslót">
            <ion-select-option *ngFor="let v of varazslok" [value]="v.id">{{ v.nev }}</ion-select-option>
          </ion-select>
        </ion-item>
      </ion-list>

      <ion-note *ngIf="iratkesz.id && iratkesz.mezok.length === 0" class="ion-padding-start" color="medium">
        Nincs kézzel kitöltendő változó – minden adat automatikusan feloldódik az ügyből.
      </ion-note>

      <ion-list *ngIf="iratkesz.mezok.length">
        <ion-list-header><ion-label>Kitöltendő mezők</ion-label></ion-list-header>
        <ion-item *ngFor="let mez of iratkesz.mezok">
          <ion-select *ngIf="mez.tipus === 'legordulo'" [label]="mez.label || mez.tag" labelPlacement="stacked" [(ngModel)]="iratkesz.ertekek[mez.tag]" interface="popover">
            <ion-select-option *ngFor="let o of mez.opciok" [value]="o">{{ o }}</ion-select-option>
          </ion-select>
          <ion-input *ngIf="mez.tipus !== 'legordulo'" [label]="mez.label || mez.tag" labelPlacement="stacked" [(ngModel)]="iratkesz.ertekek[mez.tag]"></ion-input>
        </ion-item>
      </ion-list>

      <ion-item lines="none">
        <ion-checkbox slot="start" [(ngModel)]="iratkesz.pdf"></ion-checkbox>
        <ion-label>PDF-ként (különben szerkeszthető DOCX)</ion-label>
      </ion-item>

      <ion-item lines="none" *ngIf="eszignoElerheto && iratkesz.pdf">
        <ion-checkbox slot="start" [(ngModel)]="iratkesz.alair"></ion-checkbox>
        <ion-label>Aláírás e-Szignóval<br /><small style="color:var(--ion-color-medium)">A generált PDF-et a token/kártya tanúsítványoddal írja alá (PIN-bekérés)</small></ion-label>
      </ion-item>

      <ion-button expand="block" [disabled]="keszites" (click)="general()">
        <ion-spinner *ngIf="keszites" slot="start" name="crescent"></ion-spinner>
        Irat készítése
      </ion-button>
    </ion-content>
  </ng-template>
</ion-modal>
